import React, { CSSProperties, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './Chip.module.scss';

export type ChipProps = {
    label: ReactNode;
    backgroundColor?: string;
    labelColor?: string;
    className?: string;
    testId?: string;
};

const Chip = (props: ChipProps) => {
    const { label, backgroundColor, labelColor, className, testId = '' } = props;

    const chipClassName = classNames(styles.chip, className);
    return (
        <div
            data-testid={testId}
            className={chipClassName}
            style={{ '--chip-background-color': backgroundColor, '--chip-text-color': labelColor } as CSSProperties}
        >
            {label}
        </div>
    );
};

export default Chip;
